
import AppleBusinessConnectLoginCard from '@/components/apple/AppleBusinessConnectLoginCard.vue';
import { AppleBusinessConnectPlatformData, PublicBot, SupportedPlatform } from 'ignite360-core';
import _merge from 'lodash.merge';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'public-social-login-apple-business-connect',
  components: { AppleBusinessConnectLoginCard },
})
export default class PublicSocialLoginAppleBusinessConnect extends Vue {
  @Prop({ required: true, type: Object })
  readonly bot!: PublicBot;

  onConnect(data: Partial<AppleBusinessConnectPlatformData>) {
    const newBot: PublicBot = _merge({}, this.bot, {
      platformData: {
        [SupportedPlatform.AppleBusinessConnect]: data,
      },
    });
    this.$emit('update:bot', newBot);
  }

  onDisconnect() {
    const newBot: PublicBot = _merge({}, this.bot, {
      platformData: {
        [SupportedPlatform.AppleBusinessConnect]: {
          companyId: '',
          locationId: '',
        },
      },
    });
    this.$emit('update:bot', newBot);
  }
}
